import { Document, Text, View, StyleSheet, Font } from "@react-pdf/renderer";


import { PDFPallets } from "./PDFPallets";
import { PDFPage } from "./PDFPage";
import { Report } from "../../interfaces/intakes.reports";
import { PDFImages } from "./PDFImages";
import { PDFSummary } from "./PDFSummary";
import { PDFCreatedBy } from "./PDFCreatedBy";

// @react-pdf/textkit ships hypher with the en-us Liang patterns and hyphenates
// by syllable when no callback is registered, inventing hyphens that are not in
// the source text (e.g. "appear-ance", "speci-fied"). Returning the word as a
// single chunk leaves the line breaker no split point, so words wrap whole.
Font.registerHyphenationCallback((word) => [word]);

interface Props {
    allData: Report
    charts?: Record<string, string[]>
}


export const DocuPdf = ({ allData: data, charts }: Props) => {

    return (
        <Document>

            {
                data &&
                <PDFSummary data={data} />
            }

            {
                data &&
                    data.pallets.length > 0
                    ?
                    data.pallets.map((pallet, index) => (
                        <PDFPallets key={`${pallet.pid}-${index}`} data={data} pallet={pallet} index={index} charts={charts} />
                    ))

                    :
                    <PDFPage data={data}>
                        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
                            <Text style={globalStyles.h2}>No Pallets</Text>
                        </View>
                    </PDFPage>
            }

            {/* {
                data.mainDataImages && data.mainDataImages.length > 0 &&
                <PDFPage data={data}>
                    <Text style={globalStyles.h2}>Batch Images</Text>
                    <PDFImages images={data.mainDataImages} />
                </PDFPage>
            } */}


        </Document>
    )
}

export const globalStyles = StyleSheet.create({

    // pageFormat: {
    //     flex: 1,
    //     flexDirection: "column",
    //     paddingHorizontal: 30,
    //     paddingVertical: 20,
    //     // fontFamily: "HelveticaFuente",
    // },
    // h2: {
    //     fontSize: "12px",
    //     fontWeight: 'bold',
    //     color: '#2fac66',
    //     lineHeight: '1px',
    //     marginBottom: 4
    // },
    // title: {
    //     color: "gray",
    //     fontSize: "10px",
    // },
    // text: {
    //     color: '#353644',
    //     fontSize: "10px",
    //     alignSelf: 'flex-end',
    // },
    // medium: {
    //     // fontWeight: 'medium',
    // },
    // bold: {
    //     fontFamily: "Helvetica-Bold",
    //     fontWeight: 'bold',
    // },
    // italic: {
    //     fontFamily: "Helvetica-Oblique",
    //     fontStyle: 'italic',
    // },
    // underline: {
    //     textDecoration: "underline",
    // },
    // textColor: { color: '#353644' },
    // textGreen: { color: '#2fac66', },

    // item: {
    //     flexDirection: "row",
    //     alignItems: "center",
    //     justifyContent: "space-between",
    //     alignContent: "center",
    //     paddingTop: 2.4,
    //     paddingBottom: 1.2,
    // },
    // itemBorder: {
    //     borderBottomColor: '#d8d8d8',
    //     borderBottomWidth: .5,
    // },
    // comments: {
    //     backgroundColor: '#f7f9fb',
    //     minHeight: "80px",
    //     borderRadius: 12,
    //     padding: 8,
    //     fontSize: "10.5px",
    //     lineHeight: "1.6px",
    // },
    // boxes: {
    //     minWidth: "70px",
    //     minHeight: "22px",
    //     paddingVertical: 1,
    //     paddingHorizontal: 6,
    //     borderRadius: 50,
    //     textAlign: "center",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     marginRight: '5px'
    // },
    // flexRow: {
    //     flexDirection: "row",
    //     alignItems: "center",
    //     alignContent: "center",
    // },
    // flexCenter: {
    //     alignItems: "center",
    //     alignContent: "center",
    //     justifyContent: "center",
    // },

    pageFormat: {
        flex: 1,
        flexDirection: "column",
        paddingHorizontal: 30,
        paddingVertical: 20,
        // fontFamily: "HelveticaFuente",
    },
    h2: {
        fontSize: "12px",
        fontWeight: 'medium',
        color: '#2fac66',
        lineHeight: 1.3,
        marginBottom: 4
    },
    title: {
        color: "gray",
        fontSize: "10px",
    },
    text: {
        color: '#353644',
        fontSize: "10px",
        alignSelf: 'flex-end',
    },
    medium: {
        // fontWeight: 'medium',
    },
    // Use the standard-14 PostScript variant names directly. Do NOT also set
    // fontWeight/fontStyle — that makes react-pdf look for a bold/italic variant
    // OF an already-bold/italic font, which doesn't exist ("Could not resolve font").
    bold: {
        fontFamily: "Helvetica-Bold",
    },
    italic: {
        fontFamily: "Helvetica-Oblique",
    },
    underline: {
        textDecoration: "underline",
    },
    textColor: { color: '#353644' },
    textGreen: { color: '#2fac66', },

    item: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        alignContent: "center",
        paddingTop: 2.4,
        paddingBottom: 1.2,
    },
    itemBorder: {
        borderBottomColor: '#d8d8d8',
        borderBottomWidth: .5,
    },
    comments: {
        backgroundColor: '#f7f9fb',
        minHeight: "80px",
        borderRadius: 12,
        padding: 8,
        fontSize: "10.5px",
        lineHeight: 1.4,
    },
    boxes: {
        minWidth: "70px",
        minHeight: "22px",
        paddingVertical: 1,
        paddingHorizontal: 6,
        borderRadius: 50,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        marginRight: '5px'
    },
    flexRow: {
        flexDirection: "row",
        alignItems: "center",
        alignContent: "center",
    },
    flexCenter: {
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
    },

});